var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"back"},[_c('span',{staticClass:"back_content",on:{"click":_vm.handleBack}},[_vm._v(_vm._s(_vm.$t('home.back')))])])}
var staticRenderFns = []

export { render, staticRenderFns }